import axios from '@/util/request'

export default {
  upload: function (dir, file) {
    let formData = new FormData()
    formData.append('file', file)
    let query = dir ? `dir=${dir}` : ''
    return axios.post('/api/v1/manage/file/upload?' + query, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  uploadObject: {
    init: function () {
      return {
        data: undefined,
        disabled: false,
        buttonText: '上传'
      }
    },
    canUpload: function (obj) {
      obj.disabled = false
      obj.buttonText = '上传'
    },
    cannotUpload: function (obj) {
      obj.disabled = true
      obj.buttonText = '上传中...'
    }
  }
}
